var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-tree-select", {
    staticStyle: { width: "100%" },
    attrs: {
      allowClear: "",
      labelInValue: "",
      getPopupContainer: function(node) {
        return node.parentNode
      },
      disabled: _vm.disabled,
      dropdownStyle: { maxHeight: "400px", overflow: "auto" },
      placeholder: _vm.placeholder,
      loadData: _vm.asyncLoadTreeData,
      value: _vm.treeValue,
      treeData: _vm.treeData,
      multiple: _vm.multiple
    },
    on: { change: _vm.onChange, search: _vm.onSearch }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }